import { BaseAnalytics } from "./BaseAnalytics";
import { GameAnalytics as GA } from "gameanalytics";

export class GameAnalytics extends BaseAnalytics {
    constructor() {
        super();
    }

    public logEvent(
        eventName: string, valueToSum?: number, parameters?: { [key: string]: string; }
    ): void {
        GA.addDesignEvent(
            eventName,
            valueToSum,
            parameters
        );
    }

    initialize(): void {
        GA.configureBuild(__VERSION);
        GA.initialize(
            "c3ac47796d88840405945f8eac3c187d",
            "f7b1188f2ae0b40d676035c7e9400453befba066"
        );

        // For GDPR later
        // GA.setEnabledEventSubmission(false);
    }
}
